// STORES
import { useRouterStore } from '@stores/router';
import { useApiStore } from '@stores/api';

// Custom component for dialog
import { displayNotifSuccess } from './notify.lib';
import { $t } from 'src/i18n/utils';
import { dbLoggoutActiveUser } from '@data/datasource/local/user.database';
import { RouteEnum } from '@shared/enum/route.enum';
import bus from '@shared/lib/eventbus.lib';
import { BusEventEnum } from '@shared/enum/bus/bus-events.enum';
import { apiLoggout } from '@data/datasource/remote/user.api';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';
import { BusEventDialogEnum } from '@shared/enum/bus/bus-events-dialog.enum';

/**
 * Loggout functions
 */
interface ILoggoutActions {
  showLoggoutNotif?: boolean;
  errorWhileRefreshToken?: boolean;
  from?: string;
}
export const loggoutActions = async (
  params: ILoggoutActions = { showLoggoutNotif: true },
) => {
  // Set stores
  const apiStore = useApiStore();

  if (params?.from != null) {
    sessionManager?.log(`loggoutActions - from : ${params.from}`);
  }

  // Set logging out
  sessionManager.setStatusLoggingOut();

  // Loggout user (remote first, then locally)
  await apiLoggout();
  await dbLoggoutActiveUser();

  // Cancel all current get requests
  apiStore.clearApiRequests();

  // Show loggout message
  if (params.showLoggoutNotif) {
    displayNotifSuccess($t('signin.logout.message'));
  }

  // Loggout :
  // - clear cookies
  // - clear refresh token
  // - Update session status
  sessionManager.logout();
};

export const redirectOnLoggout = () => {
  // Set stores
  const routerStore = useRouterStore();

  // Redirect if on admin page
  if (
    routerStore.activeRoute != null &&
    [RouteEnum.USERS, RouteEnum.VIDEOS, RouteEnum.CHANGELOG].includes(
      routerStore.activeRoute,
    )
  ) {
    // Redirect on home page
    bus.emit(BusEventEnum.GO_TO_HOME);
  }
}

export const closeAllModals = () => {
  // Close all dialogs
  bus.emit(BusEventDialogEnum.CLOSE_ALL_MODAL);
}
